

<div class="row">
  <div class="col-auto">
    
  </div>
</div>

<div class="row">
  <div class="col">
    <h3>Consulta/Edição/Exclusão da janela de solicitação de renúncia</h3>
  </div>
  <div class="col-auto">
    <button class="btn btn-primary" *ngIf="!estaEditando" type="button"
      (click)="voltar()">Voltar</button>

    <button type="button" *ngIf="estaEditando" class="btn btn-danger"
      (click)="cancelarEdicao()">Cancelar</button>

    <button *ngIf="estaEditando" type="button" class="btn btn-primary" (click)="salvar()">Salvar</button>
  </div>
</div>

<div class="container">

  <form [formGroup]="formJanelaRenuncia" *ngIf="estaEditando" class="form">
    <div class="row">
    </div>
    <div class="row">
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="dataInicioVigencia"><b>Data de vigência inicial: </b></label>
        <bn-datepicker idInput="dataInicioVigencia" formControlName="dataInicioVigencia" ></bn-datepicker>
      </div>

      <div class="bn-form-group col-md-4">
        <label class="form-label" for="dataFimVigencia"><b>Data de vigência final: </b></label>
        <bn-datepicker idInput="dataFimVigencia" formControlName="dataFimVigencia" ></bn-datepicker>
      </div>
    </div>
  </form>
  <div class="row">
  </div>
  <div class="container row" *ngIf="janelas?.length > 0">
    <div class="table-responsive">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th>Tipo de Janela de Renúncia</th>
                    <th>Data de vigência inicial</th>
                    <th>Data de vigência final</th>
                    <th>Data solicitação</th>
                    <th>Solicitado por</th>
                    <th class="text-align-center">Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let janela of janelas">
                  <td>{{ descricaoTipoJanela[janela.tipoJanela] }}</td>
                  <td>{{ janela.dataInicioVigencia | date: 'dd/MM/yyyy HH:mm'}}</td>
                  <td>{{ janela.dataFimVigencia | date: 'dd/MM/yyyy HH:mm'}}</td>
                  <td>{{ janela.dataCriacao | date: 'dd/MM/yyyy HH:mm'}}</td>
                  <td>{{ janela.usuarioResponsavelCadastroJanela }}</td>
                  <td class="text-align-center">
                    <i *ngIf="podeEditar(janela)" class="fa fa-pen  ms-4 text-primary"
                      [ngClass]="{'cursor-pointer': !estaEditando, 'desabilita': estaEditando}"
                      ngbTooltip="Habilita a linha selecionada para edição" (click)="iniciarEdicao(janela)"></i>
                  
                    <i *ngIf="podeExcluir(janela)" class="fa fa-trash ms-5 text-danger" (click)="prepararExcluir(janela)"
                      [ngClass]="{'cursor-pointer': !estaEditando, 'desabilita': estaEditando}"
                      ngbTooltip="Exclui a linha selecionada"></i>                  
                  </td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</div>

<ng-template #msgTemplateExcluir>
  <span
    >Esta ação irá EXCLUIR a janela de renúncia selecionada. </span>
  <br />
  <br />
  Você confirma?
  <br />
</ng-template>
<ng-template #botoesPersonalizadosExcluir>
  <button class="btn btn-md btn-success" (click)="excluir()">
    Sim
  </button>
  <button class="btn btn-md btn-danger" (click)="dismissModal()">
    Não
  </button>
</ng-template>